import { buildGlobalReferenceContext } from '../../../context/buildGlobalReferenceContext.mjs';

const [DropdownContextProvider, useDropdownContext] = buildGlobalReferenceContext("Dropdown");

export { DropdownContextProvider, useDropdownContext };
//# sourceMappingURL=context.mjs.map
